// removed by extract-text-webpack-plugin
module.exports = {"search_container":"styles__search_container___byo2z","align_search_button":"styles__align_search_button___3O2M3","buttonClass":"styles__buttonClass___2dhAk"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/Inputs/InputSearch/styles.css
// module id = 3153
// module chunks = 0